import Link from "next/link";
import { ArrowRight, LifeBuoy, MessageCircleQuestion } from "lucide-react";
import { CrisisLineAlert } from "./crisis-line-alert";

/**
 * Shared "didn't find an answer" footer: the two-link triage card grid plus
 * the crisis-line alert. Used on the audience catalogs, the article page,
 * and the search empty state so the copy and phone number stay in exactly
 * one place. The landing renders `CrisisLineAlert` on its own instead, since
 * its centered closing CTA band already covers the two links.
 */
export function SupportFooterCta() {
  return (
    <div className="space-y-6">
      <div className="grid gap-3 sm:grid-cols-2">
        <Link
          href="/asistent"
          className="group flex items-center justify-between gap-4 rounded-lg border bg-background p-4 transition-colors hover:border-brand/40 hover:bg-brand/5"
        >
          <span className="flex items-center gap-3">
            <MessageCircleQuestion className="h-5 w-5 text-brand" />
            <span>
              <span className="block text-sm font-semibold">
                Postavi pitanje
              </span>
              <span className="mt-0.5 block text-xs text-muted-foreground">
                Za brzo usmeravanje
              </span>
            </span>
          </span>
          <ArrowRight className="h-4 w-4 text-muted-foreground transition-transform group-hover:translate-x-0.5" />
        </Link>
        <Link
          href="/podrska/kontakt"
          className="group flex items-center justify-between gap-4 rounded-lg border bg-background p-4 transition-colors hover:border-brand/40 hover:bg-brand/5"
        >
          <span className="flex items-center gap-3">
            <LifeBuoy className="h-5 w-5 text-brand" />
            <span>
              <span className="block text-sm font-semibold">
                Piši podršci
              </span>
              <span className="mt-0.5 block text-xs text-muted-foreground">
                Za nalog, novac ili privatnost
              </span>
            </span>
          </span>
          <ArrowRight className="h-4 w-4 text-muted-foreground transition-transform group-hover:translate-x-0.5" />
        </Link>
      </div>
      <CrisisLineAlert />
    </div>
  );
}
